import { Phone } from "lucide-react";
import { TopBar } from "./TopBar";
import { SignOutButton } from "./AccountMenu";

export function ContactOffice() {
  return (
    <div className="rmm-bg min-h-screen">
      <TopBar right={<SignOutButton />} />
      <main className="mx-auto max-w-xl px-4 py-12 sm:px-6">
        <section data-testid="contact-office-card" className="rmm-card p-8 text-center sm:p-10">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border-2 border-[#D4AF37] bg-[#7A0016]"><Phone className="h-6 w-6 text-[#F5E6BA]" /></span>
          <h1 className="mt-5 font-display text-3xl font-bold text-[#4A000E]">Please contact the office</h1>
          <p className="mt-3 text-sm text-[#8C6A6C]">Your account is currently not active. Please contact the Real Match Matrimony office for help.</p>
        </section>
      </main>
    </div>
  );
}
